import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../../shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../../../shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../../../shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../../shared/ui/src/components/buttons/buttonConstants';
import {Icon} from '../../../../../../../shared/ui/src/components/icon/icon';

/*
 * Props.
 */

interface ImportCsvButtonProps {
  isDisabled?: boolean;
  hasHover?: boolean;
  variant?: ButtonVariantsEnum;
  onClick?: Handler;
}

/*
 * Style.
 */

const StyledButtonContentDiv = styled.div`
  display: flex;
  align-items: center;
`;

const StyledButtonIcon = styled(Icon)`
  margin-right: 8px;
`;

const StyledImportCSVButton = styled(Button)`
  margin-left: 8px;
`;

/*
 * Component.
 */

export const ImportCSVButton: FC<ImportCsvButtonProps> = ({
  isDisabled,
  hasHover,
  variant = ButtonVariantsEnum.PRIMARY,
  onClick,
}) => (
  <StyledImportCSVButton variant={variant} onClick={onClick} isDisabled={isDisabled} hasHover={hasHover}>
    <StyledButtonContentDiv>
      <StyledButtonIcon name="downloadSmall" size={16} />
      <Trans id="contacts-manager-import-csv-button">Import</Trans>
    </StyledButtonContentDiv>
  </StyledImportCSVButton>
);
